module.exports = __webpack_public_path__ + "fonts/Graphik-RegularItalic-Web.e05373e.woff2";